import request from "@/utils/request";
// import queryString from 'querystring'
// 首页列表
export function getBanner(data) {
    return request({
        url: "/home/banner/get",
        method: "get",
        params: data,
    });
}
